import moment from "moment-timezone";
import _ from "lodash";

/**
 * @typedef {{start: string, end: string, label: string}} Timestamp
 * @typedef {{name: string, data: number[]}} LineChartDatum
 * @typedef {{createdAt: string, response: string}} LineChartData
 * @property {LineChartDatum[]} series
 * @property {string[]} labels
 */

/**
 * Get the data for line charts displaying invitation activity over time.
 * @param {EventMetricInvitationItem[]} invitations
 * @param {Timestamp[]} timestamps
 * @returns {LineChartData}
 */
export default function getInvitationActivityChartData(invitations, timestamps) {
  const normalizedInvitations = invitations.map(project => ({
    ...project,
    createdAt: moment(project.createdAt),
  }))

  const seriesData = _.map(timestamps, ({ start, end, label }) => {
    const startMoment = moment(start);
    const endMoment = moment(end);

    const counts = _.transform(
      normalizedInvitations,
      (acc, invitation) => {
        const { createdAt } = invitation;

        if (createdAt.isBetween(startMoment, endMoment, null, "[]")) {
          acc.sent++;
          if (invitation.response === 'Yes') acc.yes++;
          if (invitation.response === 'Maybe') acc.maybe++;
          if (invitation.response === 'Pending') acc.pending++;
          if (invitation.response === 'No') acc.no++;
        }
      },
      { sent: 0, yes: 0, maybe: 0, pending: 0, no: 0 }
    );

    return { label, counts };
  })

  return {
    series: [
      {
        name: 'Sent',
        data: seriesData.map(d => d.counts.sent)
      },
      {
        name: 'Yes',
        data: seriesData.map(d => d.counts.yes)
      },
      {
        name: 'Maybe',
        data: seriesData.map(d => d.counts.maybe)
      },
      {
        name: 'Pending',
        data: seriesData.map(d => d.counts.pending)
      },
      {
        name: 'No',
        data: seriesData.map(d => d.counts.no)
      }
    ],
    labels: seriesData.map(d => d.label)
  }
}
